/**
 * Elements that may receive keyboard focus while a Bootstrap modal focus trap
 * is active (chat dock / float panels sit above #taskModal).
 *
 * Pure helper — unit-testable without Bootstrap.
 */
export function isChatFocusAllowed(target) {
  if (!target || typeof target.closest !== 'function') return false
  return Boolean(
    target.closest(
      '#chat-dock, #chat-dock-root, .chat-float-shadow, .chat-float-panel, .chat-composer, .chat-md-editor'
    )
  )
}
